

export const defaultLinkAGB = "https://www.velumount.ch/de/agb";
export const defaultLinkDP = "https://www.velumount.ch/de/datenschutz";
export const defaultLinkAftercare = "https://clientarea.velumount.ch/de/go/aftercare/places";
export const defaultDataProtection: boolean = true;
export const defaultDisclaimer: boolean = true;
export const defaultDefaultCountry = "CH";
